import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';
import { INTL_PREFIX } from '@/messages/const';
import { useRegionProvider } from '@/providers/RegionProvider';

export const intlPrefix = `${INTL_PREFIX.PAYMENT}.cembra`;

export const dataPrivacyPolicyOfCembraPay = (
  <FormattedMessage
    defaultMessage='Data Privacy Policy of CembraPay'
    id={`${intlPrefix}.dataPrivacyPolicyOfCembraPay`}
  />
);
export const cembraPaySATermsAndConditions = (
  <FormattedMessage
    defaultMessage='Cembra Money Bank AG Terms and Conditions'
    id={`${intlPrefix}.cembraPaySATermsAndConditions`}
  />
);

export const defined = defineMessages({
  dateOfBirth: {
    defaultMessage: `Date of birth*`,
    id: `${intlPrefix}.dateOfBirth`,
  },
  errorBirthRequired: {
    defaultMessage: `In order to verify your eligibility, please enter your date of birth.`,
    id: `${intlPrefix}.errorBirthRequired`,
  },
  errorBirthLimit: {
    defaultMessage:
      'Sorry we can only accept customers aged between 18 and 85. Please try another payment method',
    id: `${intlPrefix}.errorBirthLimit`,
  },
  cembraInvoiceDescTitle: {
    defaultMessage:
      'Purchase by Open Invoice allows you to receive your order now and pay later.',
    id: `${intlPrefix}.cembraInvoiceDescTitle`,
  },
  cembraInvoiceDescLine1: {
    defaultMessage: 'Payment is due within 30 days after receiving your order',
    id: `${intlPrefix}.cembraInvoiceDescLine1`,
  },
  cembraInvoiceDescLine2: {
    defaultMessage:
      'No interest or additional fees for using this payment method',
    id: `${intlPrefix}.cembraInvoiceDescLine2`,
  },
  cembraInvoiceAdmissionCriteriaTitle: {
    defaultMessage:
      'Admission criteria for a Purchase by Open Invoice with “CembraPay” :',
    id: `${intlPrefix}.cembraInvoiceAdmissionCriteriaTitle`,
  },
  cembraInvoiceAdmissionCriteriaItem1: {
    defaultMessage: 'Successful credit check',
    id: `${intlPrefix}.cembraInvoiceAdmissionCriteriaItem1`,
  },
  cembraInvoiceAdmissionCriteriaItem2: {
    defaultMessage: 'No debt enforcement',
    id: `${intlPrefix}.cembraInvoiceAdmissionCriteriaItem2`,
  },
  cembraSameAddressCheckbox: {
    defaultMessage:
      'I agree to use the billing address as my shipping address to proceed with the order.',
    id: `${intlPrefix}.cembraSameAddressCheckbox`,
  },
});

const BreitlingConditionsOfSale = (
  <FormattedMessage
    defaultMessage='Breitling Conditions of Sale'
    id={`${intlPrefix}.breitlingConditionsOfSale`}
  />
);
export const CembraInvoiceDescLine3 = ({
  maxAmount,
}: {
  maxAmount: string;
}) => (
  <FormattedMessage
    defaultMessage='Maximum invoice limit: {maxAmount}'
    id={`${intlPrefix}.cembraInvoiceDescLine3`}
    values={{
      maxAmount: maxAmount,
    }}
  />
);
export const CembraInvoiceDescLine4 = ({
  maxAmount,
}: {
  maxAmount: string;
}) => (
  <FormattedMessage
    defaultMessage='For invoice requests above {maxAmount}, please contact us'
    id={`${intlPrefix}.cembraInvoiceDescLine4`}
    values={{
      maxAmount: maxAmount,
    }}
  />
);

export const ConditionsOfSaleAcknowledgeForCembra = () => {
  const EXIST_LANGUAGE = ['de', 'it', 'fr', 'en'];
  const { locale } = useRegionProvider();
  const language = EXIST_LANGUAGE?.includes(locale.slug) ? locale.slug : 'en';

  const url1 = `https://cembrapay.ch/${language}/terms/CP`;
  const url2 = `https://cembrapay.ch/${language}/privacy`;
  return (
    <FormattedMessage
      defaultMessage='I have read and I accept the {breitlingConditionsOfSale} and {cembraPaySATermsAndConditions} and the {dataPrivacyPolicyOfCembraPay}.'
      id={`${intlPrefix}.consentCheckbox`}
      values={{
        breitlingConditionsOfSale: (
          <LinkWithLocale href={paths.termsAndCondition.url()} target='_blank'>
            {BreitlingConditionsOfSale}
          </LinkWithLocale>
        ),
        cembraPaySATermsAndConditions: (
          <LinkWithLocale href={url1} target='_blank'>
            {cembraPaySATermsAndConditions}
          </LinkWithLocale>
        ),
        dataPrivacyPolicyOfCembraPay: (
          <LinkWithLocale href={url2} target='_blank'>
            {dataPrivacyPolicyOfCembraPay}
          </LinkWithLocale>
        ),
      }}
    />
  );
};
